export default __webpack_public_path__ + "static/media/LuisBordaFirma.f32aa362.png";